export const getDepartmentId = (department: string) => {
  switch (department) {
    case 'legalizacao':
      return 1;
    case 'administrativo':
      return 2;
    case 'contabil':
      return 3;
    case 'fiscal':
      return 4;
    case 'pessoal':
      return 5;
    case 'auditoria':
      return 6;
    default:
      return undefined;
  }
};

export const getDepartmentName = (id: string | undefined) => {
  switch (id) {
    case '1':
      return 'Legalização';
    case '2':
      return 'Administrativo';
    case '3':
      return 'Contábil';
    case '4':
      return 'Fiscal';
    case '5':
      return 'Pessoal';
    case '6':
      return 'Auditoria';
    default:
      return undefined;
  }
};
